import * as React from 'react'
import { TableHeaderColumn } from '@/modules/drivers/types/table'
import TableTextHeader from '@/modules/drivers/shared/tableItems/TableTextHeader'

export const ActivityListHeader = ({
  columns,
}: {
  columns: TableHeaderColumn[]
}) => {
  return (
    <thead
      className={`notches-border--right tw-sticky tw-top-0 tw-z-10 tw-select-none tw-border-b tw-bg-content-primary`}
    >
      <tr>
        {columns.map((col) => (
          <TableTextHeader
            key={col.title}
            fontSize={'sm'}
            bolder={true}
            opacity={true}
            sort={col.sort}
          >
            {col.title}
          </TableTextHeader>
        ))}
      </tr>
    </thead>
  )
}
